import { I18nFragment } from '@diagentech/exprworks-ui-components';
import Link from '@mui/material/Link';
import React, { useCallback } from 'react';

import { useAppDispatch } from '@/App/hooks';
import { ABOUT_US_DIALOG_ID } from '@/components/aboutUs/AboutUsDialog';
import { setShowAboutUs } from '@/features/ui/uiSlice';

export const AboutUsLink: React.FC = () => {
  const dispatch = useAppDispatch();

  const showAboutUs = useCallback(() => {
    dispatch(setShowAboutUs(true));
  }, [dispatch]);

  return (
    <Link
      variant="body2"
      component="button"
      aria-controls={ABOUT_US_DIALOG_ID}
      aria-haspopup="true"
      onClick={showAboutUs}
    >
      <I18nFragment id="SH.PG.ABOUTUS" />
    </Link>
  );
};
